module.exports = __webpack_public_path__ + "img/other_03.bfb6d18e.jpg";